import { Box, Container, Icon, Stack, Text, styled } from '@qcx/ui';
import { Contest } from '@atreus/data';
import { Link } from '../../../components/Link';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

interface ContestCardProps {
  contest: Contest;
}

export const ContestCard = ({ contest }: ContestCardProps) => {
  return (
    <Container
      css={{
        flexCol: true,
        mt: '$6',
        bg: '$neutral50',
        borderRadius: '$4xl',
        p: '$5',
        ml: 0,
        '@md': {
          w: 720,
          flexRowCenter: true,
          height: '$20',
          justifyContent: 'space-between'
        },
        '@lg': {
          w: 1218
        }
      }}
    >
      <Box css={{ flexRow: true, gap: '$5' }}>
        <Box css={{ flexCol: true }}>
          <Text css={{ color: '$orangeDark600' }} weight="semibold">
            SALÁRIO
          </Text>
          <Text css={{ color: '$text' }} weight="semibold">
            Até {contest.salary}
          </Text>
        </Box>
        <Box css={{ flexCol: true }}>
          <Text css={{ color: '$orangeDark600' }} weight="semibold">
            CARGOS
          </Text>
          <Text css={{ color: '$text' }} weight="semibold">
            {contest.job}
          </Text>
        </Box>
        <Box css={{ flexCol: true }}>
          <Text css={{ color: '$orangeDark600' }} weight="semibold">
            VAGAS
          </Text>
          <Text css={{ color: '$text' }} weight="semibold">
            {contest.vacancies}
          </Text>
        </Box>
      </Box>
      <Stack css={{ flexColCenter: true, mt: '$4', '@md': { mt: 0 } }}>
        <StyledButtonCta to={contest.cta}>
          <Box css={{ d: 'flex', alignItems: 'center', gap: '$2' }}>
            <Text variant="sm" weight="bold">
              Conferir Concursos relacionados
            </Text>
            <Icon icon={faChevronRight} />
          </Box>
        </StyledButtonCta>
      </Stack>
    </Container>
  );
};
const StyledButtonCta = styled(Link, {
  bgColor: '$secondary500',
  fontWeight: '$bold',
  fontSize: '$sm',
  minW: '$9',
  minH: '$9',
  h: '$9',
  rounded: '$lg',
  p: '$3dot5',
  lineHeight: '$sm ',
  d: 'flex',
  flexCenter: true,
  color: '$hiContrast',
  '&:hover, &:active': {
    bgColor: '#FE6112',
    color: '$hiContrast'
  },
  '@lg': { w: '$80' }
});
